module.exports = __webpack_public_path__ + "static/media/logo.44e54b7b.png";